import { BRAND_COLORS } from '../../lib/brandColors';

/**
 * La linea rossa luminosa ("laser") sotto l'intestazione di Pixel, con la sua
 * ombra morbida. Sta in fondo al contenitore che la ospita, che deve essere
 * `relative`.
 *
 * E' un pezzo a se' perche' la usano sia l'intestazione del gestionale sia le
 * pagine pubbliche (il modulo di iscrizione ai corsi): devono essere la stessa
 * linea, non due copie che col tempo divergono.
 */
export function LineaLaser() {
  return (
    <>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-primary-500 to-transparent opacity-90"
        style={{
          boxShadow: `0 0 8px ${BRAND_COLORS[500]}, 0 0 12px ${BRAND_COLORS[500]}, 0 0 16px ${BRAND_COLORS[500]}, 0 4px 20px ${BRAND_COLORS[500]}4d`,
          filter: 'blur(0.5px)',
        }}
      />
      <div aria-hidden="true" className="pointer-events-none absolute bottom-[-4px] left-0 right-0 h-[4px] bg-primary-500/20 blur-md" />
    </>
  );
}
